/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-01-28 11:33:09
 */
import {
  defaultHomeLearningProgressSeries,
  defaultHomeLearningProgressTitle
} from '@/config-center'
import { Lecturer, SystemLessionTag, SelectedCourse, Video } from './model'
import { IndexService } from './service'
import { setManual } from '@/utils/cookies'

export class IndexManager {
  defaultTitle = defaultHomeLearningProgressTitle
  defaultSeries = defaultHomeLearningProgressSeries
  homeSerise: Array<SystemLessionTag> = []
  menuNavs: Array<any> = []
  sysTems: Array<any> = []
  studyPlan: Array<any> = []
  sysTemWithCourse: Array<any> = []
  lecturers: Lecturer[] = []
  video: Video[] = []
  showCoursePrice = true
  showLeucturer = true
  learningProgressTitle = ''
  learningProgressSeries: Array<any> = []
  selectedCourse: SelectedCourse[] = []
  service: IndexService
  constructor (service: IndexService) {
    this.service = service
    this.init()
    // this.getConfigsWithSettings()
  }

  init () {
    // this.service.getInfomationNavs().then((res: any) => {
    //   console.log(res)
    //   console.log('res========')
    //   this.menuNavs = res
    // })
    // this.getHomeConfigure()
    // this.getSelectedCourseManager()
  }

  async getHomeConfigure () {
    const orgId = await this.service.getOrgId()
    // this.getCourseSystemsFromServer(orgId)
    // this.getStudyPlanServer(orgId)
    this.getTeachersFromServer(orgId)
    // this.getMenusFromServer(orgId)
    // this.getManual(orgId)
  }

  async getSelectedCourseManager () {
    const res = await this.service.getSelectedCourse()
    console.log(res)
    this.selectedCourse = res.data.items
    this.selectedCourse = this.selectedCourse.map(item => {
      item.playNum = Math.floor((Math.random() * 1000)).toString()
      return item
    })
    console.log(this.selectedCourse)
  }

  async getSelectedCourseVideosManager (excellentId: string, coursewareId: string) {
    const result = await this.service.getSelectedCourseVideos(excellentId, coursewareId)
    console.log(result)
    this.video = result.data
    console.log(this.video)
  }

  // async getMenusFromServer (orgId: string) {
  //   const infoNavs = await this.service.getInfomationNavs()
  //   // const res = await this.service.getInfoMenus(orgId)
  //   // this.lecturers = []
  //   if (res.length === 0) {
  //     this.menuNavs = infoNavs
  //   } else {
  //     res.forEach((item: any) => {
  //       const menu = infoNavs.find((sub: any) => Number(sub.id) === Number(item))
  //       if (menu) {
  //         this.menuNavs.push(menu)
  //       }
  //     })
  //   }
  //   console.log('menuNavs', this.menuNavs)
  // }

  // async getStudyPlanServer (orgId: string) {
  //   const studyPlan = await this.service.getStudyPlan(orgId)
  //   console.log(studyPlan)
  //   this.studyPlan = studyPlan
  // }

  // getConfigsWithSettings () {
  //   this.service.getConfigWithProgress().then((res: any) => {
  //     if (res.series.length === 0) {
  //       this.learningProgressSeries = this.defaultSeries
  //       return
  //     }
  //     this.learningProgressSeries = res.series
  //   })
  //     .catch(() => {
  //       this.learningProgressSeries = this.defaultSeries
  //     })

  //   this.service.getConfigWithProgressTitle().then((res: string) => {
  //     if (!res) {
  //       this.learningProgressTitle = this.defaultTitle
  //     }
  //     this.learningProgressTitle = res
  //   })

  //   this.service.getConfigWithShowCoursePrice().then((res: boolean) => {
  //     this.showCoursePrice = res
  //   })
  //   this.service.getConfigWithShowLucturer().then((res: boolean) => {
  //     this.showLeucturer = res
  //   })
  // }

  // async getCourseSystemsFromServer (orgId: string) {
  //   const courseSysTemArr = await this.service.getSystemLessionService()
  //   console.log('courseSysTemArr', courseSysTemArr)
  //   const res = await this.service.getCourseSystems(orgId)
  //   res.forEach((item: any) => {
  //     const system = courseSysTemArr.find((sub: any) => item.id === sub.id)
  //     if (system) {
  //       item.title = system.title
  //     }
  //   })
  //   this.homeSerise = []
  //   if (res.length === 0) {
  //     courseSysTemArr.forEach((item: any, index: number) => {
  //       if (index % 2 !== 0) {
  //         const tag = new SystemLessionTag(
  //           item.id,
  //           item.title,
  //           '',
  //           'line',
  //           'lesson',
  //           []
  //         )
  //         this.homeSerise.push(tag)
  //       } else {
  //         const children: Array<any> = this.getCourseSysTemHandler(
  //           item.id,
  //           courseSysTemArr
  //         )
  //         const tag = new SystemLessionTag(
  //           item.id,
  //           item.title,
  //           '',
  //           'circle',
  //           'lessonSystem',
  //           children
  //         )
  //         this.homeSerise.push(tag)
  //       }
  //     })
  //   } else {
  //     res.forEach((item: any) => {
  //       if (item.category === 'lesson') {
  //         const tag = new SystemLessionTag(
  //           item.id,
  //           item.title,
  //           '',
  //           item.display,
  //           item.category,
  //           []
  //         )
  //         this.homeSerise.push(tag)
  //       } else {
  //         const children: Array<any> = this.getCourseSysTemHandler(
  //           item.id,
  //           courseSysTemArr
  //         )
  //         const tag = new SystemLessionTag(
  //           item.id,
  //           item.title,
  //           '',
  //           item.display,
  //           item.category,
  //           children
  //         )
  //         this.homeSerise.push(tag)
  //       }
  //     })
  //   }
  // }

  async getTeachersFromServer (orgId: string) {
    const teachers = await this.service.getLecturers()
    const res = await this.service.getTeachers(orgId)
    this.lecturers = teachers.filter((item: any) => res.indexOf(item.id) !== -1)
    this.lecturers = []
    if (res.length === 0) {
      this.lecturers = teachers
    } else {
      res.forEach((item: any) => {
        const teacher = teachers.find((sub: any) => sub.id === item)
        if (teacher) {
          this.lecturers.push(teacher)
        }
      })
    }
    console.log('lecturers', this.lecturers)
  }

  getCourseSysTemHandler (
    courseSysId: string,
    resourseArr: Array<any>
  ): Array<any> {
    for (let i = 0; i < resourseArr.length; i++) {
      if (resourseArr[i].id === courseSysId) {
        return resourseArr[i].children
      } else {
        if (resourseArr[i].children.length > 0) {
          const children = this.getCourseSysTemHandler(
            courseSysId,
            resourseArr[i].children
          )
          if (children.length > 0) {
            return children
          }
        }
      }
    }
    return []
  }

  // async getManual (orgId: string) {
  //   const res = await this.service.getManual(orgId)
  //   setManual(res.student || '')
  // }

  get informationNavs () {
    // 云南普洱项目去掉指导文字限制
    return this.menuNavs.filter((nav: any) => {
      return !/(合作)/g.test(nav.title)
    })
  }

  get partnersNavs () {
    // 云南普洱项目去掉指导文字限制
    return this.menuNavs.filter((nav: any) => {
      return /(合作)/g.test(nav.title)
    })
  }
}
